import { network } from 'services/network';

import { QueryParams } from 'api/queries/getBoardInit.query';

export const getCardResourceInit = (params: QueryParams) => {
    const url = `api/bo/boardinit/getCardResourceInit?metaDataId=${params.metaDataId}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
